import { Column } from "./types";

export const ZURICH_CSI_REPORT = 'CSI Trigger Report';

export const ZURICH_CSI_REPORT_MESSAGE =
  'CSI Triggers for delivered jobs entries for the chosen date range';

export const ZURICH_CSI_REPORT_GRID_TITLE = 'CSITriggerReport';

export const columns: Column[] = [
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'registration', title: 'Registration' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'model', title: 'Model' },
  { name: 'dateReturned', title: 'Date Returned', type: 'date' },
  { name: 'elapsedK2K', title: 'Elapsed K2K' },
  { name: 'comments', title: 'Comments', width: '300' },
];